import React from "react";
import { Rating, Star } from "@smastrom/react-rating";

const ProductRatingView = ({ reviewCount, reviewAverage }) => {
  return (
    <div className="flex items-center">
      {reviewAverage && (
          <>
            <Rating
              style={{ maxWidth: 140 }}
              value={reviewAverage}
              readOnly
              spaceBetween="small"
              itemStyles={{
                itemShapes: Star,
                // activeFillColor: "#FFC83D",
                activeFillColor: "#000000",
                inactiveFillColor: "#EEEEEE",
                // itemStrokeWidth: 2,
                // activeStrokeColor: "#000",\
              }}
            />
        </>
      )}
      {!!reviewCount && (
          <span className="mt-[4px] text-xs sm:text-sm font-medium underline underline-offset-2 px-[14px]">{reviewCount} reviews</span>
      )}
    </div>
  );
};

export default ProductRatingView;
